import {classNames} from "@/library/utilities/html"
import useAuth from "@/library/auth/_hook.auth"
import {pageGroups, pages} from "@/page-definitions"
import {ReactNode, useEffect} from "react"
import {Link} from "@tanstack/react-router"

type MainMenuProps = {
    mode: 'vertical' | 'horizontal'
}

export default function MainMenu(props: MainMenuProps) {
    const {mode} = props

    const {roles, logout, isLoading} = useAuth()

    if (isLoading)
        return <>Laster...</>

    const pageList = Object.values(pages).filter(p => {
        if (p.navGroup && pageGroups[p.navGroup].requiresRole) {
            const itemRoles = pageGroups[p.navGroup].requiresRole ?? []
            for (const role of itemRoles) {
                if (!roles.includes(role)) {
                    return false
                }
            }
        }

        if (p.requiresRole) {
            for (const role of p.requiresRole) {
                if (!roles.includes(role)) {
                    return false
                }
            }
        }

        return true
    })
    const nodes: ReactNode[] = []

    const renderMenuItem = (name: string, link: string, icon: ReactNode = <></>) => <li key={name}>
        <Link to={link} params="" search="">
            {icon} {name}
        </Link>
    </li>

    let previousWasGroup = false
    while (pageList.length > 0) {
        const page = pageList.shift()

        if (!page) {
            console.error("No page found... Got undefined...")
            continue
        }

        if (page.isNavItem === false)
            continue

        if (!page.navGroup) {
            if (previousWasGroup)
                nodes.push(<li key={`${page.navName}_separator`} className="menu-separator menu-separator--horizontal"></li>)

            nodes.push(renderMenuItem(page.navName, page.navLink, page.navIcon))
            continue
        }

        previousWasGroup = true
        const group = pageGroups[page.navGroup]
        const pagesInGroup = [page, ...pageList.filter(p => p.navGroup == page.navGroup)]
        pagesInGroup.forEach(p => {
            const index = pageList.indexOf(p)

            if (index >= 0)
                pageList.splice(index, 1)
        })

        nodes.push(<li key={group.name} className="menu-group-title">
            <div className="title">{group.name}</div>
            {group.description && <div className="sub-title">{group.description}</div>}
        </li>)

        pagesInGroup.forEach(p =>
            nodes.push(renderMenuItem(
                p.navName, p.navAppend === false
                    ? p.navLink
                    : group.url + p.navLink,
                p.navIcon
            ))
        )
    }

    return <nav className={classNames("menu", "menu--main", `menu-${mode}`)}>
        <ul>
            {nodes.map(node => node)}
            <li className="menu-separator menu-separator--horizontal"></li>
            <li><a href="#" onClick={logout}><i className="fas fa-sign-out"></i> Logg ut</a></li>
        </ul>
    </nav>
}
